import { DeletedFormNS, DeletedFormSchema } from "@smart/bridge-types-basic";
import { buildTableDef } from "@smart/itops-constructs-basic";
import { wrapSchema } from "@smart/itops-utils-basic";

const deletedFormGuard = wrapSchema(DeletedFormSchema);

export const DeletedFormDef = buildTableDef(
  {
    namespace: DeletedFormNS,
    guard: deletedFormGuard,
    keyFields: ["uri"],
    keySchema: { uri: "string" },
    ttlField: "deletedAtSec",
  } as const,
  {
    byForm: {
      indexName: "byForm",
      keyFields: ["formUri", "updatedAt"],
      keySchema: { formUri: "string", updatedAt: "string" },
    },
    byOwner: {
      indexName: "byOwner",
      keyFields: ["teamUri", "updatedAt"],
      keySchema: { teamUri: "string", updatedAt: "string" },
    },
  } as const,
);
